import React from 'react'
import CompanyToInvoice from '../Pages/Documents/document/common/CompanyToInvoice'
import CreditNote from '../Pages/Documents/document/stepCreditNote/CreditNote'
import Invoice from '../Pages/Documents/document/stepInvoice/Invoice'
import PurchaseOrderStep from '../Pages/Documents/document/stepInvoice/PurchaseOrderStep'
import SelectDocument from '../Pages/Documents/document/common/SelectDocument'
import Invoice01 from '../Pages/Documents/document/stepInvoice/invoice/Invoice01'
import Invoice02 from '../Pages/Documents/document/stepInvoice/invoice/Invoice02'
import Invoice03 from '../Pages/Documents/document/stepInvoice/invoice/Invoice03'

const steps = (documentType, step,values,setFieldValue) => {
    //En este lista se deben poner los paso enumerados para cada documento
    //Recordar que la KEY se puede duplicar, lo que hara unico al obj es KEY+documentType
    //TODO: Hacer la key dinamico para evitar errores a futuro    
    const listSteps = [{
        key: 0,
        documentType: "all",
        component: <CompanyToInvoice documentType={documentType}/>,
        title: "Empresa a Facturar"
    },
    {
        key: 1,
        documentType: "all",
        component: <SelectDocument  />,
        title: "Seleccione Documento"
    }   
    ];
    
    let stepToReturn;

    if(step===-1){
        return listSteps.filter(x=>x.documentType==='all' || x.documentType===documentType)
    }
    if (step < 2) {
        stepToReturn = listSteps.find(x => x.key === step);
    } else {
        stepToReturn = listSteps.find(x => x.key === step && x.documentType === documentType);
    }
    return (stepToReturn)
}

export const ComponentByDocumentAndStep = (documentType, step,values,setFieldValue) => {
    
    return (steps(documentType, step,values,setFieldValue).component)
}

export const LabelByDocumentAndStep = (setDocument, step) => {
    return (steps(setDocument, step).title)
}

export const StepsByDocument = (documentType, seDocumentType) => {
    return (steps(documentType, seDocumentType,-1))
}

